export default __webpack_public_path__ + "static/media/p11.d20eb5fc.jpg";